import React, { ReactNode } from 'react'
import { IconS24CrossCircle24Filled } from '@is24/cosma-ui-icons'
import styles from './AiDataExtractionUploadError.module.css'

type AiDataExtractionUploadErrorProps = {
  message: ReactNode
  className?: string
  'data-testid'?: string
  role?: 'alert'
}

export const AiDataExtractionUploadError = ({
  message,
  className = '',
  'data-testid': dataTestId,
  role,
}: AiDataExtractionUploadErrorProps) => (
  <div
    className={`font-body-small-bold-important font-error ${styles.uploadError}${className ? ` ${className}` : ''}`}
    data-testid={dataTestId}
    role={role}
  >
    <IconS24CrossCircle24Filled />
    <span>{message}</span>
  </div>
)
